<template>
  <span class="Tag-Value" :class="get_modify"><slot /></span>
</template>

<script setup>
  import { computed } from 'vue';
  import { Props } from './scripts/props.js';
  //-----------------------------------------------
  const props = defineProps(Props());
  //-----------------------------------------------
  const get_modify = computed(() => props.type ? `Tag-Value--${props.type}` : '');
</script>

<style lang="scss">
  @import "./styles/_conf";
</style>